import { createAction } from '@reduxjs/toolkit';
export const UPDATE_CONVERSATION_PARTICIPANTS = 'UPDATE_CONVERSATION_PARTICIPANTS';
export const updateConversationParticipantsAction = createAction(UPDATE_CONVERSATION_PARTICIPANTS, (messageSessionId, participants) => ({
  payload: { messageSessionId, participants }
}));